import React, { Component } from 'react';
import { MapboxService } from '../../../services/mapboxService';
import "./Map.scss";
import {StateHandlerService} from '../../../services/stateHandlerService';
import adesisServices from '../../../services/adesisServices'
import {valuesMap} from '../../../utils/data';
import axios from "axios";
import {Redirect} from 'react-router';
export default class Map extends Component {
  constructor() {
    super();
    this.state = {
      redirectToCarRegistration: false
    }
    this.controls = {};
    this.service = axios.create({
      baseURL: process.env.REACT_APP_SERVICE_ADESIS_URL
    });  
    this.mapboxService = new MapboxService();
    this.stateService = new StateHandlerService();
    this.adesisServices = new adesisServices();
   

   
  }
  async componentDidMount() {

    this.mapboxService.init();

    if (this.adesisServices.param){
     
      
      let dealers= await this.mapboxService.getDealersByParams(this.adesisServices.param)
      console.log(dealers)
      if (dealers['length']){
        this.stateService.publishControls({start:0,end:Math.min(5,dealers['length'])})
        this.stateService.publishDealers(dealers);
        }
    }
    this.stateService.publishProgressLineInfo({step:1,info:{}})
    this.stateService.controls$.subscribe(controls=>{
      this.controls=controls;
    })

    this.stateService.dealers$.subscribe(dealers=>{
      this.mapboxService.map['clearMarkers']()
      this.mapboxService.map['addMarkers'](this.dealersToShow(dealers), {
        fitToBounds: true,
        markerImage: "toyota-black-text",
        markerClick:(order)=>{this.manageMarkerClick(order)}

        
      
      });
      this.fixNumberMarkers()
    })
   
    this.mapboxService.map['focusOn'](valuesMap().COUNTRY)
  }


  dealersToShow(dealers){
    return dealers.slice(this.controls['start'],this.controls['end'])
  }
  fixNumberMarkers(){
    let markers=this.mapboxService.map['markers']
  
    markers.forEach((marker,index) => {
      marker.element.getElementsByTagName('text')[0].innerHTML=(index+this.controls['start']+1).toString();
    });
     
    
   
  }

  manageMarkerClick(order){
    let dealer = this.mapboxService.map.markers[order].location;
    this.props.setRedirectToInit();

    let workshop = {
      DealershipId: dealer.localDealerID,
      DealershipName: dealer.name,
      DealershipAddress: dealer.address.address1,
      DealershipCity: dealer.address.city,
      DealershipZipCode: dealer.address.zip
    }

    this.props.getWorkshopSelect(workshop)

    //  this.service
    // .get(
    //   `/Concesionario/GetConcesionariosByActivity?bMecanica=1&bChapa=0&bRepuestos=0`
    // )
    // .then(response => {
    //   let dealerFiltered = response.data.Data.filter( element =>
    //   //  parseInt(element.DealershipId .split('-')[0])+'-' + parseInt(element.DealershipId.split('-')[1]) == parseInt(dealer.localDealerID.split('-')[0])+'-'+parseInt(dealer.localDealerID.split('-')[1])
    //     parseInt(element.DealershipId.split('-')[1]) == parseInt(dealer.localDealerID.split('-')[0]) && element.DealershipZipCode == dealer.address.zip
    //   )

    //   let workshop = dealerFiltered[0]
    //   workshop.DealershipAddress = dealer.address.address1
    //   workshop.DealershipCity = dealer.address.city
    //   workshop.DealershipName = dealer.name
    //   workshop.DealershipZipCode = dealer.address.zip

    //   // this.props.getWorkshopSelect(dealerFiltered[0]);
    //   this.props.getWorkshopSelect(workshop)
    // }
      
    //   )
    // .catch(e => console.log(e));
 
    this.setState({redirectToCarRegistration:true})
  }

  
  render() {
   
    if (this.state.redirectToCarRegistration) {
      // return <Redirect to="/carRegistration" />;
      return <Redirect to="/modelSelector" />;
    }
    
    
    return (
        <div >
 

{

<div className="map-container">
<div id="map">

  
</div>

</div> 

}

      </div>
    )
  }
}


